
const CTABanner = () => {
  return (
    <section className="relative py-24 overflow-hidden">
      {/* Background Image */}
      <div 
        className="absolute inset-0 bg-cover bg-center"
        style={{
          backgroundImage: 'url(https://public.readdy.ai/ai/img_res/7177ab517b065465ce2b61e306662bec.jpg)',
        }}
      ></div>
      
      {/* Dark Overlay */}
      <div className="absolute inset-0 bg-gradient-to-r from-navy/95 via-navy/90 to-navy/95"></div>

      {/* Content */}
      <div className="relative z-10 max-w-7xl mx-auto px-6 lg:px-8 text-center">
        <h2 className="text-4xl lg:text-5xl font-extrabold text-white mb-6">
          READY TO GET STARTED?
        </h2>
        <p className="text-xl text-gray-200 mb-8 max-w-3xl mx-auto">
          Experience professional electrical services with a fresh, customer-focused approach.<br />
          Contact us today for a free quote on your residential, commercial, or industrial project.
        </p>

        <div className="flex flex-col sm:flex-row gap-4 justify-center items-center">
          <a
            href="/contact"
            className="bg-gold text-navy px-8 py-4 rounded-lg font-bold text-base tracking-wider hover:bg-gold-light transition-all whitespace-nowrap cursor-pointer flex items-center gap-2"
          >
            REQUEST A QUOTE
            <i className="ri-arrow-right-line text-xl"></i>
          </a>
          <a
            href="tel:+61400000000"
            className="bg-white text-navy px-8 py-4 rounded-lg font-bold text-base tracking-wider hover:bg-gray-100 transition-all whitespace-nowrap cursor-pointer flex items-center gap-2"
          >
            <i className="ri-phone-fill text-xl"></i>
            CALL NOW
          </a>
        </div>
      </div>
    </section>
  );
};

export default CTABanner;
